// extracted by mini-css-extract-plugin
module.exports = {"header":"Xu8S0Wtu8Ztf7jU2lM0A","buttons":"Zd1KJpBKFMHOlhcfuqCd"};